export default __webpack_public_path__ + "71118d656779eb77d9f90738dd1af781.svg";